import gql from 'graphql-tag';

export const UPDATE_APPOINTMENT = gql`
  mutation(
    $appointmentId: String!
    $providerUserId: String
    $schedule: ScheduleInput
    $allowedConversationTypes: [ConversationType!]
    $status: AppointmentStatus
    $providerGroupSpecialtyId: Int
  ) {
    updateAppointment(
      input: {
        appointmentId: $appointmentId
        providerUserId: $providerUserId
        schedule: $schedule
        allowedConversationTypes: $allowedConversationTypes
        providerGroupSpecialtyId: $providerGroupSpecialtyId
        status: $status
      }
    ) {
      appointmentId
    }
  }
`;
